/* Keep this form's fields only for retrying a failed native Shopify submission.
   Tab-scoped, expires after 30 minutes, cleared on success; no analytics or AJAX. */
(() => {
  const form = document.querySelector('[data-lpda-pro] #LPDAProEditorialContact');
  if (!form) return;
  const key = 'lpda-professional-contact-retry';
  const fields = [...form.querySelectorAll('input:not([type="hidden"]), select, textarea')]
    .filter(field => field.name.startsWith('contact['));
  const clear = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  if (form.querySelector('[data-pro-success]')) { clear(); return; }
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved && Date.now() - saved.at < 30 * 60 * 1000 && saved.path === location.pathname) {
      if (form.querySelector('.pro-errors')) {
        fields.forEach(field => {
          if (typeof saved.values[field.name] === 'string') field.value = saved.values[field.name];
        });
      }
    } else clear();
  } catch (_) { clear(); }
  form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    const values = Object.fromEntries(fields.map(field => [field.name, field.value]));
    try { sessionStorage.setItem(key, JSON.stringify({at: Date.now(), path: location.pathname, values})); } catch (_) {}
  });
})();
